module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "margin-bottom": "100px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "justify-center": ""
    }
  }, [_c('item-list', {
    attrs: {
      "allowAdd": "",
      "allowDelete": "",
      "endpoint": _vm.endpoint + 'apikeys',
      "editRoute": "apikeyEdit",
      "headers": _vm.headers,
      "id": "_id",
      "name": "API Key",
      "searchBarText": _vm.searchBarText,
      "permissions": "apikeys"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-406250a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApiKeys.vue
// module id = 421
// module chunks = 1